export default __webpack_public_path__ + "static/Plain-Extrabold-bf8fffa8687c804b95aadf4a7e8d07f3.woff";